module.exports = __webpack_public_path__ + "img/qc1.832818ea.png";